import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import moment from "moment";
import { Select as ReactSelect } from "common-components/FormContent";
import {
  fetchRequestHistory,
  fetchPageContent,
  setBreadCrumbListInRedux,
  fetchFormerRequestHistory
} from "../../../MainContent/DownloadAndDelete/actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { cleanDateFormat } from "utils/cleanDateFormat";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { media } from "utils/style";
import { ENDPOINTS } from "utils/endpoints";
import { checkNestedObject } from "utils/checkNestedObject";
import CommonHeader from "common-components/Header";
import Alert from "common-components/Alert";
import CommonContainer from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import { convertStringToElements } from "@vds/html-parsers";
import FallbackUI from "../../FallbackUI/FallbackUI";
import GoBack from "common-components/GoBack";
import StyledLinkSmall from "common-components/StyledLinkSmall";
import { Redirect } from "react-router-dom";
import { checkAMLob } from "utils/checkAMLob";
class FormerAndGuestRequestHistory extends Component {
  state = {
    showMaxPasswordModal: false,
    statusText: {},
    loading: true,
    selectedFormerAccount: [],
    requestHistoryData: [],
    pageName: ""
  };



  componentDidMount() {
    const { ccpaFlow } = window.reactGlobals;
    const { location } = this.props;
    const queryString = window.location.search;
    if (this.props.BreadCrumbsLink != "") {
      let pageContentUrl;
      if (ccpaFlow === "FORMER") {
        pageContentUrl = ENDPOINTS.FETCH_FORMER_REQUEST_HISTORY;
      } else {
        pageContentUrl = ENDPOINTS.FETCH_GUEST_REQUEST_HISTORY;
      }
      this.props.fetchPageContent(pageContentUrl).then(() => {
        this.setState({ loading: false });
        this.setPageContent();
      });

      if (this.props.BreadCrumbsLink && this.props.BreadCrumbsLink[2] && this.props.BreadCrumbsLink[2].isSelectBox) {
        const { formerIdInfo, accountList } = this.getFormerIdAndAccounts();
        if (formerIdInfo && formerIdInfo.trim().length > 0) {
          if (accountList && accountList.length > 0) {
            this.props.fetchFormerRequestHistory(accountList[0]).then(() => {
              this.setState({
                requestHistoryData: [...this.props.elementsData]
              })
            })
          }
        }
      } else {
        this.props.fetchRequestHistory().then(() => {
          this.setState({
            requestHistoryData: [...this.props.elementsData]
          })
        });
      }
    } else {

      this.setState({
        loading: false
      })
    }
  }


  setPageContent = () => {
    const { pageContent } = this.props;
    const history_details = pageContent.sections[1]

    if (checkNestedObject(history_details[1].statusText)) {
      this.setState({ statusText: history_details[1].statusText[0] });
    }

    if (checkNestedObject(pageContent.gnavDropdown)) {
      this.props.setBreadCrumbListInRedux({ gnavDropdown: pageContent.gnavDropdown });
    }

    if (checkNestedObject(pageContent.breadCrumbs)) {
      const { location } = this.props;

      this.props.setBreadCrumbListInRedux({ breadCrumbs: pageContent.breadCrumbs });

      let landingPageTest;
      if (location.state && location.state.PreviouspageName) {
        landingPageTest = location.state.PreviouspageName

      } else {
        landingPageTest = this.props.BreadCrumbsLink && this.props.BreadCrumbsLink[0] ? this.props.BreadCrumbsLink[0].requestStatusPageName : null
      }

      this.props.setBreadcrumbList([
        { label: pageContent.breadCrumbs.landingPage, path: landingPageTest },
        { label: pageContent.breadCrumbs.requestHistory, }
      ]);
    }

    if (checkNestedObject(history_details[1].sc_pagetitle)) {
      this.props.setA11yContent("Your request history", history_details[1].sc_pagetitle);
    }
  };



  renderRequestType = type => {

    const { statusText } = this.state;

    if (type === "DOWNLOAD" || type === "DOWNLOAD_AFFIDAVIT") {
      return statusText.download;
    } else if (type === "DELETE") {
      return statusText.deletion;
    } else if (type.toLowerCase() === "agent authorization") {
      return statusText.agentAuthorization;
    } else if (type === "APPEAL") {
      return statusText.appeal;
    } else if (type === "CORRECT") {
      return statusText.correct;
    }

    return type;
  };



  renderAppealColumn = (item, amLob) => {
    const history_details = this.props.pageContent.sections[1][1];
    const { buttons } = history_details;
    const { uniqueTxnId, requestType, state, emailId, role } = item;
    const { location } = this.props
    let appealContent = "";
    let appealConfirmationContent = "";
    let pendingModelContent = "";

    appealContent = this.props.pageContent.sections[2]["appeal"][0];
    appealConfirmationContent = this.props.pageContent.sections[2]["appeal"][1];
    pendingModelContent = this.props.pageContent.sections[1][2]

    const isAnyDownloadInProgress = this.props.elementsData.filter((item) => item.requestType === "DOWNLOAD" && item.status === "IN_PROGRESS").length > 0;
    const requestHistoryPath = "/privacy/your-data/request-history"

    const accountIdentifiers = window.reactGlobals.formerAcctsInfo.accountIdentifiers ? window.reactGlobals.formerAcctsInfo.accountIdentifiers : [];
    let valueObj = {};
    if (accountIdentifiers && accountIdentifiers.length > 0) {
      accountIdentifiers.forEach(accID => {
        valueObj[accID.identifier] = accID.value;
      })
    }
    let FirstName;
    let lastName;
    if (valueObj) {
      FirstName = valueObj.firstName ? valueObj.firstName : null
      lastName = valueObj.lastName ? valueObj.lastName : null
    }
    let appealData = {
      intent: "Appeal",
      serviceType: this.props.serviceType,
      email: emailId,
      txnId: uniqueTxnId,
      accountId: this.props.accountId,
      FirstName: FirstName,
      lastName: lastName,
      role: role,
      state: state,
      appealType: requestType
    }

    return (
      <StyledLinkSmall
        key={uniqueTxnId}
        background={buttons[0].type}
        disabledStatus={isAnyDownloadInProgress ? "disabled" : ""}
        to={{
          pathname: "/privacy/your-data/submit-appeal",
          state: {
            confirmAuth: true,
            payload: appealData,
            appealContent,
            appealConfirmationContent,
            requestHistoryPath: requestHistoryPath,
            pendingModelContent: pendingModelContent
          }
        }}
      >
        {buttons[0].text}
      </StyledLinkSmall>
    );

  }
  /* end of added for APPEAL */

  renderStatusColumn = ({ requestType, status, requestedBy, downloadAvailabilityDeadline, ...rest }) => {
    let statusText = status;
    return this.transformStatusText(statusText);
  };


  getFormerIdAndAccounts = () => {
    const formerIdInfo = window.reactGlobals.formerAcctsInfo ? window.reactGlobals.formerAcctsInfo.formerId : "";
    let accountList = [];
    if (formerIdInfo) {
      accountList = window.reactGlobals.formerAcctsInfo.accountInfo ? window.reactGlobals.formerAcctsInfo.accountInfo : [];
    }
    return {
      formerIdInfo,
      accountList
    };
  }

  handleAccountChange = (event) => {
    const selectedAccountIdx = parseInt(event.target.value);
    const { formerIdInfo, accountList } = this.getFormerIdAndAccounts();
    if (formerIdInfo && accountList) {
      const selectedAccount = accountList.filter((accountInfo, idx) => idx === selectedAccountIdx);
      this.setState({
        selectedFormerAccount: [...selectedAccount],
        requestHistoryData: []
      }, () => {
        this.props.fetchFormerRequestHistory(this.state.selectedFormerAccount[0]).then(() => {
          this.setState({
            requestHistoryData: [...this.props.elementsData]
          })
        })
      });

    }

  }

  isEligibleForAppeal = ({ status, appealFlag }) => {
    //for now checking against the status.
    //once the flag is ready i will use the same.
    const { cpraFlagEnabled } = window.reactGlobals;
    return ("DENIED" === status && "Y" === appealFlag && (undefined !== cpraFlagEnabled && "Y" === cpraFlagEnabled));
  }

  renderTableContent = (historyArray, fullNameForWln) => {
    const { statusText } = this.state;
    const amLob = checkAMLob();
    return historyArray.map(item => {
      const formattedDate = moment(cleanDateFormat(item.dateOfRequest), "YYYY-MM-DD HH:mm:ss").format(
        "MMM D, YYYY h:mma"
      );

      return (
        <TR key={item.uniqueTxnId}>
          <TD>
            <StatusSpan>{formattedDate}</StatusSpan>
          </TD>
          <TD>
            <StatusSpan>{this.renderRequestType(item.requestType)}</StatusSpan>
          </TD>
          <TD>{this.renderStatusColumn(item)}</TD>
          {/* DPCMP - 156,155,163 Request Number column */}
          { window.reactGlobals.requestNumberFFlag ?
          <TD>{item.requestNumber}</TD>
          :
          ""
          }

          <Fragment>
            {/* added for APPEAL */}
            {
              true === this.isEligibleForAppeal(item)
                ?
                <TD>{!this.props.loading && item ? this.renderAppealColumn(item) : ""}</TD>
                :
                ""
            }
            {/* end of added for APPEAL */}
          </Fragment>

        </TR>
      );
    });
  };

  transformStatusText = status => {
    const cleanStr = typeof status === "string" ? status.toUpperCase() : status;
    const { statusText } = this.state;

    switch (cleanStr) {
      case "REMOVED":
        return statusText.removed;
      case "APPROVED":
        return statusText.approved;
      case "FILE_EXPIRED":
        return statusText.fileExpired;
      case "FILE_AVAILABLE":
        return statusText.fileAvailable;
      case "REQUEST_PENDING":
        return statusText.requestPending;
      case "EXPIRED":
        return statusText.expired;
      case "IN_PROGRESS":
        return statusText.inProgress;
      case "COMPLETED":
        return statusText.completed;
      case "CANCELLED":
        return statusText.cancelled;
      case "CANCEL_COMPLETE":
        return statusText.cancelled;
      case "PENDING_PROCESS":
        return statusText.pendingProcess;
      case "PARTIALLY_COMPLETED":
        return statusText.partiallyCompleted;
      case "REJECTED":
        return statusText.rejected;
      case "DELETED":
        return statusText.deleted;
      case "NOT APPROVED":
        return statusText.notApproved;
      case "DENIED":
        return statusText.denied;
      case "APPEAL_DENIED":
        return statusText.appealDenied;
      case "APPEAL_COMPLETED":
        return statusText.appealComplete;
      case "APPEAL_PENDING":
        return statusText.appealPending;
      case "APPEAL_CANCELLED":
        return statusText.cancelled;
      case "PENDING":
        return statusText.pendingApproval;
      default:
        return status;
    }
  };


  render() {
    if (this.state.loading) {
      return <RectangleLoader style={{ padding: "0 16px" }} />;
    }

    if (this.props.BreadCrumbsLink === "") {
      return <FallbackUI />;
      // return <Redirect to={this.props.location.state.PreviouspageName} />;
    }

    const { pageContent, location } = this.props;
    const { requestNumberFFlag } = window.reactGlobals;
    const no_history = pageContent.sections[1];
    const sectionList = pageContent.sections[1]
    const appealProof = pageContent.sections[2].appeal_proof
    const { accountList } = this.getFormerIdAndAccounts();
    
    {/* DPCMP - 156,155,163 Request Number column */}

    if(!requestNumberFFlag)
    {
      sectionList[1].genericList[0].list =  sectionList[1].genericList[0].list.filter(
        item =>    item.jsonKey !== "requestnumberheading" 
      )
    }

    if (this.props.error) {
      return <FallbackUI />;
    } else if (!pageContent) {
      return <FallbackUI />;
    } else {
      return (
        <Container>

          <div className="goBack">
            <GoBack className={"goBackButton"} />
          </div>
          {this.props.loading ? (
            <RectangleLoader
              style={{
                position: "absolute",
                padding: "0px 16px",
                top: "0",
                left: "0",
                bottom: "0",
                right: "0",
                background: "#fff",
                animation: "0",
                margin: "0"
              }}
            />
          ) : null}
          {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}
          <Div>
            <Header>{sectionList[0].section_title}</Header>
            {this.props.BreadCrumbsLink && this.props.BreadCrumbsLink[2] && this.props.BreadCrumbsLink[2].isSelectBox ?
              <Select id={"selectAccountId"} onChange={(e) => this.handleAccountChange(e)}>
                {
                  accountList.map((accountInfo, idx) => (
                    <option key={accountInfo.billingAccountNumber + "_" + accountInfo.indicator + "_" + idx} value={idx}>
                      {accountInfo.firstName} {accountInfo.lastName} : {accountInfo.billingAccountNumber}
                    </option>
                  ))
                }
              </Select>
              : null}
            {this.state.requestHistoryData && this.state.requestHistoryData.length ? (
              <Table>
                <thead>
                  <TRH>
                    {sectionList[1].genericList[0].list.map(item => (
                      <TH key={item.jsonKey}>
                        <Span>{item.jsonValue}</Span>
                      </TH>
                    ))}
                  </TRH>
                </thead>
                <tbody>{this.renderTableContent(this.state.requestHistoryData, this.props.fullNameForWln)}</tbody>
              </Table>

            ) : (
              <P>{no_history[0].genericList[0].list[0].jsonValue}</P>
            )}

          </Div>
          <div>

            <TabeleBottomDescribtion>
              {convertStringToElements(appealProof.Category[0].category_description)}
            </TabeleBottomDescribtion>
          </div>
        </Container>
      );
    }
  }
}

const mapStateToProps = ({
  requestHistory: { elementsData, fullNameForWln, accountId, serviceType },
  loadingAndErrorState: { loading, error },
  profileInformation: deviceList,
  downloadAndDelete: { noOfPwdNotificationRemaining },
  pageContent: {
    maximum_passwords_reached: modalContent,
    resend_password: resend_password_page,
    ...pageContent
  },
  BreadCrumbsLink
}) => ({
  elementsData,
  fullNameForWln,
  loading,
  error,
  deviceList,
  noOfPwdNotificationRemaining,
  modalContent,
  resend_password_page,
  pageContent,
  BreadCrumbsLink,
  accountId,
  serviceType
});

FormerAndGuestRequestHistory.propTypes = {
  requestHistory: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string
};

export default connect(
  mapStateToProps,
  {
    fetchRequestHistory,
    setA11yContent,
    setBreadcrumbList,
    fetchPageContent,
    setBreadCrumbListInRedux,
    fetchFormerRequestHistory
  }
)(FormerAndGuestRequestHistory);

const Header = styled(CommonHeader)`
  margin-bottom: 54px;

  ${media.mobile`
    margin-bottom: 40px;
  `}
`;

const StatusSpan = styled.span`
  ${media.tablet`
    max-width: 100px;
    display: inline-table;
  `}

  ${media.mobile`
    max-width: 100px;
    display: inline-table;
  `}
`;

const Div = styled.div`
  max-width: 809px;
  overflow: auto;

  ${media.tablet`
    margin: 0 auto;
  `}
`;

const Span = styled.span`
  display: block;

  ${media.mobile`
    max-width: 73px;
  `}
`;

const Table = styled.table`
  font-size: 14px;
  line-height: 16px;
  width: 100%;

  ${media.mobile`
    font-size: 12px;
    line-height: 14px;
  `}
`;

const P = styled.p`
  padding: 20px 0;
  border-bottom: 1px solid;
  border-top: 4px solid #000;
`;



const TR = styled.tr`
  border-bottom: 1px solid #D8DADA;
`;

const TRH = styled.tr`
  border-bottom: 2px solid #000;

 
`;

const TH = styled.th`
  text-align: left;
  padding: 19px 0px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  min-width: 105px;

  ${media.tablet`
    min-width: 130px;  
  `}

  ${media.mobile`
    padding: 14px 0;
    min-width: 90px;
  `}
`;

const TD = styled.td`
  padding: 24px 0px;

  ${media.mobile`
    padding: 20px 0px;    
  `}
`;
const Container = styled(CommonContainer)`
  max-width: 596px;
  margin: 0px 0px 0px 20px;
  padding: 47px 0px ;

  .goBack{
    display:flex;
  }
  .goBackButton{
    margin : 0 0 40px 0;
  }
  ${media.mobile`
  margin: "0";
    padding: 48px 16px ;
  `}
`;

const Select = styled(ReactSelect)`
  width: 332px !important;
  padding: 12px !important;
  min-width: inherit !important;
  height: inherit !important;
  margin-bottom: 40px;
  border: 1px solid #6F7171;
  
`;

const TabeleBottomDescribtion = styled.div`
 padding: 20px 0;
 p{
  font-family: Verizon NHG DS;
  font-size: 12px;
  font-style: normal;
 line-height: 16.8px; 

 a{
  font-family: Verizon NHG DS;
  font-size: 12px;
  font-style: normal;
  padding-left:2px;
 }
}


`;